import React, { useEffect, useState } from 'react'
import {
  Card, CardBody, CardHeader, Container
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import 'date-fns';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import axios from 'axios';
import 'react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css';
import { EventSchema } from './validation';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import { FormSelect, FormInput, FormTextArea, FormRadio} from "_components/FormElements/FormInput";
import { ModalSpinner } from 'views/Hoc/Spinner';
import { MailBannerUploader } from 'views/Hoc/ProfileUpload';
import { Spinner } from "views/Hoc/Spinner";
import { commonService } from '_services/common.service';

const EventSocialShare = ({ eventId }) => {

  const [loading, setLoading] = useState(false);
  const [shareDataForEvent, setShareDataForEvent] = useState([])
   const [shareImage, setShareImage] = useState('');
   const [eventShareImage, setEventShareImage] = useState('');
 
  let [state, setState] = useState({ sharetype: null,
     title: null,
     content: null, 
     eventtitle:null,
     eventShareButton: null,
     shareTypeId: null,
     id:null,
     eventMailBannerId: null,
     eventMailBanner: null,
     });
 
  const { register, handleSubmit, control, errors, watch, formState } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(EventSchema),
  });

  useEffect(() => {
    //getHotelName()
    getSocialShareEvent()
  }, [])

  const getSocialShareEvent = async () => {
    setLoading(true);
    await axios.get(`channelAdmin/getSocialShareText/${eventId}`)
      .then((res) => {
        console.log('res.datares.data ',res.data)
        setShareDataForEvent(res.data);
        // let sta = {
        //   eventShareImageId: res.data[0].eventShareImageId ? res.data[0].eventShareImageId : null,
        //   eventShareImage: res.data[0].eventShareImage,
        //   eventShareButton: res.data[0].eventShareButton
        // }
        // setState({ ...state,  sta});
        res.data.map((x) => { 
          console.log(+x.shareTypeId ,'==' ,1)
            if(x.shareTypeId == 1) 
            {        
            setState({ ...state, shareText: x.shateText, eventtitle: x.title , shareTypeId: 1, id: x.id,  eventShareImageId: x.eventShareImageId ? x.eventShareImageId : null, eventShareImage: x.eventShareImage, eventShareButton: x.eventShareButton});
           
            } 
            
          });
        setLoading(false)
      })
      .catch((err) => console.log(err))
  }


 const saveContent = async() => {

  console.log('statestatestate : ', state)
   let data = { title : state.eventtitle,
                shareText : state.shareText,
                eventId:eventId,
                eventShareButton:state.eventShareButton,
                shareTypeId: state.shareTypeId,
                id:state.id,
                eventShareImageId:state.eventShareImageId,
                eventShareImage:state.eventShareImage
              }
              console.log('data : ', data)
    setLoading(true);
    await axios.post('channelAdmin/saveSocialShareText', data)
      .then((res) => {
        getSocialShareEvent();
        setLoading(false)
      })
      .catch((err) => console.log(err))          
  }

  const handleChangeShareImage = event => {
    const data = event.target.files[0]; 
    if (data && data['type'].split('/')[0] === 'image') {
      let file = data;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => { 
        setShareImage(
          reader.result
        );        
      };

    }

  };

  const handleFilter = (input, value) => {
    
    console.log('handleFilter',input, value)
     let shareId = 1
     if(value == 'Linkedin'){
      shareId = 1
     }if(value == 'FaceBook'){
      shareId = 2
     }
     console.log('share Id',shareId)
     console.log('shareDataForEvent : ',shareDataForEvent)


     setState({ ...state, shareText: '', eventtitle: '', shareTypeId: shareId, id: null, shareTypeId: shareId});
     let addupdateCnt = shareDataForEvent.map((x) => { 
      console.log(+x.shareTypeId ,'==' ,shareId)
        if(x.shareTypeId == +shareId) 
        {        
        setState({ ...state, shareText: x.shateText, eventtitle: x.title , shareTypeId: shareId, id: x.id,  eventShareImageId: x.eventShareImageId ? x.eventShareImageId : null, eventShareImage: x.eventShareImage, eventShareButton: x.eventShareButton});
        return;
        } 
        
      });
     //console.log('popdata :', addupdateCnt)   
  }

  const handlessChange = (input)=> (e) => {
    if(input == 'eventShareButton'){
      console.log('e.target.value  : ', e.target.value )
      setState({ ...state, [input]: e.target.value == 'true' ? true:false });
    } else {
      setState({ ...state, [input]: e.target.value });
    }   
  }

    const selectShareImage = async (data) => {
      if (data) {
        setShareImage('');
        var random = Math.random();
        var fileName = random + '.png';
        var file = dataURLtoFile(data, fileName);
        const formData = new FormData();
        formData.append('file', file);
        setLoading(true);
        const resImagePath = await commonService.fileUploadService(formData, '/mediaupload/upload/' + 'banner');
        if (resImagePath) {
          setEventShareImage(resImagePath.data.url);
          console.log('resImagePath: ', resImagePath)
          setState({ ...state, eventShareImage: resImagePath.data.url, eventShareImageId: '' });
          setLoading(false);
        }
  
      }
  
    }
    
    function dataURLtoFile(dataurl, filename) {

      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
  
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
  
      return new File([u8arr], filename, { type: mime });
    }
  
  return (
    <Container className="col-lg-9 col-md-9 col-sm-12  " fluid>
      {/* {
        roomModal == true && <SetRoom hotelName={hotelNameForSetupRoom} hotelCountry={hotelCountryForSetupRoom} hotelAddress={hotelAddressForSetupRoom} roomModal={roomModal} setRoomModal={setRoomModal} hotelId={hotelId} eventId={eventId} tblHotelByEventCountryId={tblHotelByEventCountryId} eventFromDate={eventFromDate} eventToDate={eventToDate} />
      } */}
      <Card>
        <CardHeader>
          <h2 style={{ textAlign: "center", color: "#2ca5cd" }}>Social Share Content</h2>
        </CardHeader>
        <CardBody>
          <ToastsContainer position="top_right" autoClose={5000} store={ToastsStore} />
          
          <div className="row">
            <div className="col-lg-12 mt-3">
              <FormRadio
                name="eventShareButton"
                className="text-sm d-inline mb-0"
                label="Share Button in FO Event Pannel"
                options={eventShareButtonOption}
                control={control}
                register={register}
                onChange={handlessChange('eventShareButton')}
                value={state.eventShareButton}
                defaultValue={state.eventShareButton}
                error={errors.eventShareButton}
              />
            </div>

            <div className="col-lg-6 mt-3">
              <div>
              <div>
              <FormInput
                id="eventtitle"
                type="text"
                name="eventtitle"
                placeholder="Event Title*"
                register={register}
                defaultValue={state.eventtitle}
                error={errors.eventtitle}
                value={state.eventtitle}
               onChange={handlessChange('eventtitle')}
              />
            </div>
            </div>
            </div>
            <div className="col-lg-6 mt-3">
            <div className="form-group">
              
            {/* <FormSelect
                  id="shareType"
                  defaultValue={state.shareType}
                  value={state.shareType}
                  label="Share Type"
                  style={{width:"90%", padding:"5px", backgroundColor:"#fff;"}}
                  placeholder="Select Share Type"
                  options={["Linkedin","FaceBook"]}
                  register={register}
                  error={errors.shareType}
                 handleChangeSelect={handleFilter}                
                /> */}
            </div>
            </div>
            <div className="col-lg-12 mt-6">
            <div className="form-group">
                <FormTextArea
                  className="buytext2 w-100"
                  id="shareText"
                  name="shareText"
                  placeholder="Tell us about your share content *"
                  onChange={handlessChange('shareText')}
                  value={state.shareText}
                />
            </div>
            </div>

          <div className="col-lg-12" style={{marginTop:"2.5rem"}}>
            
            <input type="text" style={{ position: "absolute", left: "-10000px", top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }} id="eventBanner" name="eventBanner" ref={register} value={state.eventMailBanner} />
            
            <h4 style={{ textAlign: 'left', display: 'inline-block' }}>Event Share Image </h4>
            <h5 style={{ float: 'right' }}>(Accepts Jpeg / Jpg / Png Only, Image Size Should Not Exceed 5 mb)</h5>
            <div className="form-group mt-3" style={{ height: 'auto' }}>
              <MailBannerUploader img={state.eventShareImageId ? process.env.REACT_APP_CDN_URL + state.eventShareImage : eventShareImage ? process.env.REACT_APP_CDN_URL_TEMP + eventShareImage : process.env.REACT_APP_DEFALTIMAGE+'document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg'}
                handleChange={handleChangeShareImage} selectImg={selectShareImage} image={shareImage} handleCropClose={e => setShareImage('')}
              />
              {loading && <div style={{
                position: 'relative', display: 'block',
                top: '50%',
                left: '50%',
                zIndex: '1000',
              }}><Spinner /></div>}
            </div>
            <div className="text-right"><span><i>* 546 X 546 (Use a resolution of 1:1) </i></span></div>
          </div>

            <div className="col-lg-12 mt-6">
            <div className="form-group">
              <button onClick={saveContent}>Save</button>
            </div>
            </div>           
          </div>

          {loading == true && <ModalSpinner />}

          <div style={{ display: loading == true ? "none" : 'block' }}>
            {
              shareDataForEvent.length > 0 ?
                <ToolkitProvider
                  data={shareDataForEvent}
                  keyField="id"
                  columns={[
                    {
                      dataField: "shareTypeId",
                      text: "Share Name",
                      style:{width:"17", textWrap:"auto"},
                      sort: true,
                      formatter: (row) => (
                        <div>{(row == 1)? 'LinkedIn':'FaceBook'}</div>
                      )

                    },
                    {
                      dataField: "title",
                      text: "Title",
                      style:{width:"20%", textWrap:"auto"},
                      sort: true,
                      formatter: (row) => (
                        <>
                          <div>{row}</div>
                          
                        </>
                      )
                    },
                    {
                      dataField: "shateText",
                      text: "Content",
                      style:{width:"70%", textWrap:"auto"},
                      sort: true,
                      formatter: (row) => (
                        <>
                          <div>{row}</div>
                          
                        </>
                      )
                    }
                  ]}
                  search
                  >
                  {props => (
                    <div className="table-responsive">
                      <div
                        id="datatable-basic_filter"
                        className="dataTables_filter mb-2"
                        style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}
                      >
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingTop: "10px", paddingBottom: "10px" }}>
                        </div>
                      </div>
                      <BootstrapTable
                        bordered={false}
                        classes={`table-striped table-hover`}
                        {...props.baseProps}
                        bootstrap4={true}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                :

                <h4 style={{ textAlign: "center", marginTop: "4rem" }}>Please Add Social Share content for Event</h4>
            }
        </div>
        </CardBody>
      </Card>
    </Container>
  )
}
const sharetypeOption = [
  { value: "1", label: "LinkedIN" },
  { value: "2", label: "FaceBook" },
];

const eventShareButtonOption = [
  { value: true, label: "Show" },
  { value: false, label: "Hide in FO DashBoard" },
]

export default EventSocialShare

